// page-dashboard.js — character roster dashboard (default route). Cards show live HP/MP/EXP, map, connection
// stage and license; search / filter / sort / grouping; infinite scroll; realtime via App.ws; 3-step onboarding
// empty state for new users. View prefs persist in localStorage. Ported from the legacy grid/list UI.
'use strict';
(function () {
  const App = window.App;
  const t = App.t;
  const esc = App.esc;

  App.i18n.add({
    ko: {
      dash_search_ph: '이름 · 계정 · 서버 검색', dash_filter: '필터', dash_view: '보기',
      dash_filter_licensed: '라이선스 있음', dash_filter_unlicensed: '라이선스 없음',
      dash_sort: '정렬', dash_sort_recent: '최근 활동순', dash_sort_name: '이름순', dash_sort_level: '레벨 높은순',
      dash_sort_adena: '아데나 많은순', dash_sort_index: '지정 순서',
      dash_group_machine: '머신별 묶기', dash_view_grid: '카드 보기', dash_view_list: '목록 보기',
      dash_counts: '온라인 {0} · 전체 {1}', dash_machine_none: '머신 미지정', dash_lv: 'Lv {0}',
      dash_cs_offline: '연결 끊김', dash_cs_reconnecting: '재연결 중', dash_cs_bridge: '게임 꺼짐', dash_cs_launching: '실행 중', dash_cs_ingame: '인게임',
      dash_no_license_cta: '라이선스를 연결하세요', dash_no_slot_cta: '계정 슬롯을 연결하세요',
      dash_empty_title: '아직 표시할 캐릭터가 없습니다',
      dash_empty_desc: '게임이 접속하면 캐릭터가 자동으로 나타납니다. 시작까지 3단계만 끝내세요.',
      dash_step1: '머신 가져오기 — 공유 풀에서 내 PC를 가져옵니다.',
      dash_step2: '계정 슬롯 추가 — 머신에 게임 계정(이메일)을 등록합니다.',
      dash_step3: '라이선스 등록·연결 — 라이선스를 등록하고 슬롯에 연결합니다.',
      dash_empty_cta: '머신 설정 시작', dash_go_licenses: '라이선스로 이동',
      dash_noresult_title: '조건에 맞는 캐릭터가 없습니다', dash_clear_filter: '필터 초기화',
      dash_load_fail: '목록을 불러오지 못했습니다.',
      dash_adena: '아데나',
      dash_ag_ingame: '인게임', dash_ag_terms: '약관 동의', dash_ag_server: '서버 선택', dash_ag_login: '로그인',
      dash_ag_charsel: '캐릭터 선택', dash_ag_lobby: '로비', dash_ag_unknown: '미식별', dash_ag_notgoal: '대기',
      dash_ag_hunting: '사냥 중', dash_ag_idle: '대기', dash_ag_moving: '이동 중'
    },
    'zh-CN': {
      dash_search_ph: '搜索名称 · 账号 · 服务器', dash_filter: '筛选', dash_view: '视图',
      dash_filter_licensed: '有授权', dash_filter_unlicensed: '无授权',
      dash_sort: '排序', dash_sort_recent: '最近活动', dash_sort_name: '名称', dash_sort_level: '等级从高到低',
      dash_sort_adena: '金币从多到少', dash_sort_index: '指定顺序',
      dash_group_machine: '按机器分组', dash_view_grid: '卡片视图', dash_view_list: '列表视图',
      dash_counts: '在线 {0} · 共 {1}', dash_machine_none: '未指定机器', dash_lv: 'Lv {0}',
      dash_cs_offline: '连接断开', dash_cs_reconnecting: '重新连接中', dash_cs_bridge: '游戏关闭', dash_cs_launching: '启动中', dash_cs_ingame: '游戏中',
      dash_no_license_cta: '请连接授权', dash_no_slot_cta: '请连接账号槽',
      dash_empty_title: '暂无可显示的角色',
      dash_empty_desc: '游戏接入后角色会自动出现。只需完成 3 步即可开始。',
      dash_step1: '领取机器 — 从共享池领取我的 PC。',
      dash_step2: '添加账号槽 — 在机器上登记游戏账号（邮箱）。',
      dash_step3: '注册并连接授权 — 注册授权并连接到账号槽。',
      dash_empty_cta: '开始设置机器', dash_go_licenses: '前往授权',
      dash_noresult_title: '没有符合条件的角色', dash_clear_filter: '清除筛选',
      dash_load_fail: '无法加载列表。',
      dash_adena: '金币',
      dash_ag_ingame: '游戏中', dash_ag_terms: '条款同意', dash_ag_server: '选择服务器', dash_ag_login: '登录',
      dash_ag_charsel: '选择角色', dash_ag_lobby: '大厅', dash_ag_unknown: '未识别', dash_ag_notgoal: '待机',
      dash_ag_hunting: '狩猎中', dash_ag_idle: '待机', dash_ag_moving: '移动中'
    }
  });

  // ── view preferences (localStorage) ──
  const PREFS_KEY = 'dash.prefs';
  const SORTS = ['recent', 'name', 'level', 'adena', 'index'];
  function loadPrefs() {
    let p = {};
    try { p = JSON.parse(localStorage.getItem(PREFS_KEY) || '{}') || {}; } catch (_) { p = {}; }
    return {
      view: p.view === 'list' ? 'list' : 'grid',
      sort: SORTS.includes(p.sort) ? p.sort : 'recent',
      group: !!p.group
    };
  }
  function savePrefs(st) {
    try { localStorage.setItem(PREFS_KEY, JSON.stringify({ view: st.view, sort: st.sort, group: st.group })); } catch (_) {}
  }

  // ── pure helpers ──
  function isOffline(c) {
    return (c.online === false) || (c.online == null && Date.now() - (c.updated_at || 0) > 30000);
  }
  const CS_TONE = { offline: 'bad', reconnecting: 'warn', bridge: 'warn', launching: 'info', ingame: 'ok' };
  function connBadge(c) {
    const s = c.conn_stage || (isOffline(c) ? 'offline' : 'ingame');
    if (s === 'ingame') return '';          // in-game is the healthy state → no badge
    const tone = CS_TONE[s] || 'neutral';
    return `<span class="badge ${tone}">${esc(t('dash_cs_' + s))}</span>`;
  }
  const AGENT_I18N = { '인게임': 'ingame', '약관동의': 'terms', '서버선택': 'server', '로그인': 'login', '캐릭선택': 'charsel', '로비': 'lobby', '미식별': 'unknown', '목표 단계 아님': 'notgoal', '사냥중': 'hunting', '대기': 'idle', '이동': 'moving' };
  function agentLabel(s) {
    if (s == null || s === '') return '';
    const k = AGENT_I18N[String(s).trim()];
    return k ? t('dash_ag_' + k) : String(s);
  }
  function bar(kind, cur, max, label) {
    const p = App.fmt.pct(cur, max);
    const tip = label + ' ' + App.fmt.num(cur) + ' / ' + App.fmt.num(max);
    return `<div class="ch-bar ${kind}" title="${esc(tip)}"><i style="width:${p}%"></i></div>`;
  }

  App.page('dashboard', {
    title: () => t('nav_dashboard'),
    nav: { group: 'main', order: 10, icon: '📊' },
    render(root, params) {
      const prefs = loadPrefs();
      const st = {
        q: '', filter: 'all', sort: prefs.sort, view: prefs.view, group: prefs.group,
        chars: new Map(), order: [], offset: 0, next: 0, loading: false, done: false, destroyed: false
      };

      root.innerHTML = `<div class="page dash">
        <div class="page-head">
          <div class="titles"><h1>${esc(t('nav_dashboard'))}</h1><div class="desc" id="dashCounts">${esc(t('loading'))}</div></div>
          <div class="actions"><button class="btn secondary" id="dashRefresh">↻ ${esc(t('refresh'))}</button></div>
        </div>
        <div class="toolbar">
          <input type="search" id="dashSearch" placeholder="${esc(t('dash_search_ph'))}" aria-label="${esc(t('search'))}">
          <div class="seg" id="dashFilter" role="group" aria-label="${esc(t('dash_filter'))}">
            <button type="button" data-f="all">${esc(t('all'))}</button>
            <button type="button" data-f="licensed">${esc(t('dash_filter_licensed'))}</button>
            <button type="button" data-f="unlicensed">${esc(t('dash_filter_unlicensed'))}</button>
          </div>
          <select id="dashSort" aria-label="${esc(t('dash_sort'))}">
            ${SORTS.map(s => `<option value="${s}"${st.sort === s ? ' selected' : ''}>${esc(t('dash_sort_' + s))}</option>`).join('')}
          </select>
          <label class="check"><input type="checkbox" id="dashGroup"${st.group ? ' checked' : ''}> ${esc(t('dash_group_machine'))}</label>
          <div class="seg" id="dashView" role="group" aria-label="${esc(t('dash_view'))}">
            <button type="button" data-v="grid" title="${esc(t('dash_view_grid'))}" aria-label="${esc(t('dash_view_grid'))}">▦</button>
            <button type="button" data-v="list" title="${esc(t('dash_view_list'))}" aria-label="${esc(t('dash_view_list'))}">☰</button>
          </div>
        </div>
        <div id="dashBody" class="dash-body"></div>
        <div id="dashSentinel" aria-hidden="true"></div>
      </div>`;

      const $ = (sel) => root.querySelector(sel);
      const countsEl = $('#dashCounts');
      const bodyEl = $('#dashBody');
      const sentinelEl = $('#dashSentinel');
      const searchEl = $('#dashSearch');

      // ── card markup ──
      function cardHtml(c) {
        if (!c) return '';
        const stale = isOffline(c) && c.conn_stage !== 'reconnecting';   // 재연결 중 카드는 흐리게 처리하지 않음
        const lv = `<span class="badge neutral">${esc(t('dash_lv', c.level || 0))}</span>`;
        const cb = connBadge(c);
        const lic = App.licenseBadge(c.license);
        const map = esc(App.cat.mapLabel({ map_id: c.map_id, x: c.x, y: c.y }));
        const acct = esc([c.game_account, c.server_name].filter(Boolean).join(' · '));
        const stageTxt = esc([agentLabel(c.stage), agentLabel(c.status)].filter(Boolean).join(' · '));
        const adena = `<div class="small ch-adena">${esc(t('dash_adena'))} ${esc(App.fmt.num(c.adena == null ? 0 : c.adena))}</div>`;
        const spr = c.spr != null ? App.cat.spriteThumb(c.spr, 52) : '';
        let cta = '';
        if (c.slot_id == null) cta = `<a class="ch-cta banner warn" href="#/machines">⚠ <span>${esc(t('dash_no_slot_cta'))}</span></a>`;
        else if (!c.license) cta = `<a class="ch-cta banner warn" href="#/licenses">⚠ <span>${esc(t('dash_no_license_cta'))}</span></a>`;

        if (st.view === 'list') {
          return `<div class="card ch-card list ${stale ? 'stale' : ''}" data-cid="${c.id}" id="ch-${c.id}" role="button" tabindex="0" aria-label="${esc(c.name)}">
            <div class="ch-main">
              <div class="ch-ident"><span class="ch-name truncate">${esc(c.name)}</span> ${lv} ${cb}</div>
              <div class="small muted truncate">${acct}</div>
              ${adena}
            </div>
            <div class="ch-list-bars">${bar('hp', c.hp, c.max_hp, 'HP')}${bar('mp', c.mp, c.max_mp, 'MP')}</div>
            <div class="small muted truncate ch-map">${map}</div>
            <div class="ch-list-end">${lic}</div>
            ${App.supplyShortBanner(c.supply_short)}${cta}
          </div>`;
        }
        return `<div class="card ch-card ${stale ? 'stale' : ''}" data-cid="${c.id}" id="ch-${c.id}" role="button" tabindex="0" aria-label="${esc(c.name)}">
          <div class="ch-top">
            <div class="ch-ident grow"><span class="ch-name truncate">${esc(c.name)}</span> ${lv} ${cb}</div>
            ${lic}
          </div>
          <div class="ch-body">
            ${spr ? `<div class="ch-spr">${spr}</div>` : ''}
            <div class="ch-info grow">
              <div class="small muted truncate">${acct}</div>
              ${stageTxt ? `<div class="small muted truncate">${stageTxt}</div>` : ''}
              <div class="ch-bars">
                ${bar('hp', c.hp, c.max_hp, 'HP')}
                ${bar('mp', c.mp, c.max_mp, 'MP')}
                ${c.exp_pct != null ? `<div class="ch-bar exp" title="EXP ${esc(c.exp_pct)}%"><i style="width:${Math.min(100, parseFloat(c.exp_pct) || 0)}%"></i></div>` : ''}
              </div>
              <div class="small truncate ch-map">${map}</div>
              ${adena}
            </div>
          </div>
          ${App.supplyShortBanner(c.supply_short)}${cta}
        </div>`;
      }

      function skeletons(n) {
        let s = '';
        for (let i = 0; i < n; i++) {
          s += `<div class="card ch-card skel" aria-hidden="true">
            <div class="ch-top"><span class="skeleton" style="width:45%;height:16px"></span><span class="skeleton" style="width:60px;height:16px"></span></div>
            <div class="ch-body"><div class="skeleton ch-spr-skel"></div>
            <div class="ch-info grow"><span class="skeleton" style="width:70%;height:11px"></span><span class="skeleton" style="width:50%;height:11px"></span><span class="skeleton" style="width:100%;height:9px"></span><span class="skeleton" style="width:100%;height:9px"></span></div></div></div>`;
        }
        return `<div class="dash-cards ${st.view}">${s}</div>`;
      }

      function emptyState() {
        const filtered = st.filter !== 'all' || st.q.trim() !== '';
        if (filtered) {
          return `<div class="empty-state"><div class="empty-icon">🔍</div><p>${esc(t('dash_noresult_title'))}</p>
            <button class="btn secondary" id="dashClear">${esc(t('dash_clear_filter'))}</button></div>`;
        }
        return `<div class="empty-state onboard"><div class="empty-icon">🎮</div>
          <h2>${esc(t('dash_empty_title'))}</h2>
          <p class="desc">${esc(t('dash_empty_desc'))}</p>
          <ol class="dash-steps">
            <li>${esc(t('dash_step1'))}</li>
            <li>${esc(t('dash_step2'))}</li>
            <li>${esc(t('dash_step3'))}</li>
          </ol>
          <div class="row">
            <a class="btn primary" href="#/machines">${esc(t('dash_empty_cta'))}</a>
            <a class="btn secondary" href="#/licenses">${esc(t('dash_go_licenses'))}</a>
          </div></div>`;
      }

      function renderBody() {
        if (!st.order.length) {
          bodyEl.className = 'dash-body';
          bodyEl.innerHTML = st.loading ? skeletons(8) : emptyState();
          const clr = bodyEl.querySelector('#dashClear');
          if (clr) clr.onclick = () => { st.filter = 'all'; st.q = ''; searchEl.value = ''; syncToolbar(); reload(); };
          return;
        }
        if (st.group) {
          const groups = new Map();
          for (const id of st.order) {
            const c = st.chars.get(id);
            const key = c.machine_label || '\u0000none';
            if (!groups.has(key)) groups.set(key, []);
            groups.get(key).push(c);
          }
          const keys = [...groups.keys()].sort((a, b) => a === '\u0000none' ? 1 : b === '\u0000none' ? -1 : String(a).localeCompare(String(b)));
          bodyEl.className = 'dash-body grouped';
          bodyEl.innerHTML = keys.map(k => {
            const label = k === '\u0000none' ? t('dash_machine_none') : k;
            return `<section class="dash-group"><div class="dash-group-head">🖥 <span class="truncate">${esc(label)}</span> <span class="badge neutral">${groups.get(k).length}</span></div>
              <div class="dash-cards ${st.view}">${groups.get(k).map(cardHtml).join('')}</div></section>`;
          }).join('');
        } else {
          bodyEl.className = 'dash-body';
          bodyEl.innerHTML = `<div class="dash-cards ${st.view}">${st.order.map(id => cardHtml(st.chars.get(id))).join('')}</div>`;
        }
      }

      function updateCard(c) {
        const el = root.querySelector('#ch-' + c.id);
        if (!el) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = cardHtml(c);
        el.replaceWith(tmp.firstElementChild);
      }

      function updateCounts() {
        let online = 0;
        for (const id of st.order) { const c = st.chars.get(id); if (c && !isOffline(c)) online++; }
        countsEl.textContent = t('dash_counts', online, st.order.length) + (st.done ? '' : '+');
        App.setNavCount('dashboard', online);
      }

      function applyStates(states) {
        let touched = false;
        for (const s of (states || [])) {
          const c = st.chars.get(s.character_id);
          if (!c) continue;
          Object.assign(c, s);
          // live states carry nearby_json (not spr) → derive this character's own sprite from its player entry
          if (s.nearby_json) { try { const me = JSON.parse(s.nearby_json).find(n => n && n.kind === 'player' && n.spr != null); if (me) c.spr = me.spr; } catch (_) {} }
          updateCard(c); touched = true;
        }
        if (touched) updateCounts();
      }

      async function loadMore() {
        if (st.loading || st.done || st.destroyed) return;
        st.loading = true;
        if (!st.order.length) renderBody();   // skeletons for the first page
        const r = await App.api('/api/characters', { query: { q: st.q, filter: st.filter, sort: st.sort, offset: st.offset, limit: 60 } });
        if (st.destroyed) return;
        st.loading = false;
        if (!r.ok) {
          if (!st.order.length) {
            bodyEl.innerHTML = `<div class="empty-state"><div class="empty-icon">⚠</div><p>${esc(t('dash_load_fail'))}</p>
              <button class="btn secondary" id="dashRetry">${esc(t('retry'))}</button></div>`;
            const rb = bodyEl.querySelector('#dashRetry'); if (rb) rb.onclick = reload;
          } else App.toast(App.errorText(r.data), 'error');
          return;
        }
        const chs = (r.data && r.data.characters) || [];
        for (const c of chs) { if (!st.chars.has(c.id)) st.order.push(c.id); st.chars.set(c.id, c); }
        st.next = r.data ? r.data.next : null;
        if (st.next == null) st.done = true; else st.offset = st.next;
        renderBody();
        App.ws.subscribe(st.order);
        updateCounts();
      }

      function reload() {
        st.offset = 0; st.next = 0; st.done = false; st.loading = false;
        st.chars.clear(); st.order = [];
        bodyEl.innerHTML = skeletons(8);
        loadMore();
      }

      // ── toolbar wiring ──
      function syncToolbar() {
        root.querySelectorAll('#dashFilter button').forEach(b => b.classList.toggle('on', b.dataset.f === st.filter));
        root.querySelectorAll('#dashView button').forEach(b => b.classList.toggle('on', b.dataset.v === st.view));
      }
      syncToolbar();

      let searchTimer = 0;
      searchEl.oninput = () => {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => { st.q = searchEl.value.trim(); reload(); }, 250);
      };
      root.querySelector('#dashFilter').onclick = (e) => {
        const b = e.target.closest('button[data-f]'); if (!b) return;
        st.filter = b.dataset.f; syncToolbar(); reload();
      };
      root.querySelector('#dashView').onclick = (e) => {
        const b = e.target.closest('button[data-v]'); if (!b) return;
        st.view = b.dataset.v; savePrefs(st); syncToolbar(); renderBody();
      };
      root.querySelector('#dashSort').onchange = (e) => { st.sort = e.target.value; savePrefs(st); reload(); };
      root.querySelector('#dashGroup').onchange = (e) => { st.group = e.target.checked; savePrefs(st); renderBody(); };
      root.querySelector('#dashRefresh').onclick = reload;

      // ── card click / keyboard → character page ──
      bodyEl.addEventListener('click', (e) => {
        if (e.target.closest('a, button')) return;
        const card = e.target.closest('[data-cid]');
        if (card) App.navigate('#/char/' + card.dataset.cid + '/overview');
      });
      bodyEl.addEventListener('keydown', (e) => {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-cid]')) {
          e.preventDefault();
          App.navigate('#/char/' + e.target.dataset.cid + '/overview');
        }
      });

      // ── infinite scroll ──
      const io = new IntersectionObserver((entries) => {
        if (entries.some(en => en.isIntersecting)) loadMore();
      }, { rootMargin: '400px' });
      io.observe(sentinelEl);

      // ── realtime ──
      const offStates = App.ws.on('states', (m) => applyStates(m.states));
      const offRoster = App.ws.on('roster', () => reload());

      reload();

      return () => {
        st.destroyed = true;
        io.disconnect();
        offStates(); offRoster();
        clearTimeout(searchTimer);
        App.setNavCount('dashboard', 0);
      };
    }
  });
})();
